import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   ui: {
 *     dashboard: {
 *       loading: {
 *         fetching: boolean,
 *         deleting: string[],
 *       },
 *       page: import('modules/global/generic.types').Page,
 *       filters: { text: string, sort: string },
 *     },
 *     modal: {
 *       open: boolean,
 *       entityId: string | null,
 *       creating: boolean,
 *       updating: boolean,
 *     }
 *   },
 *   data: import('./data.js').WhitelistDataEntity
 * }} WhitelistReducer
 */

export default combineReducers({
  data,
  ui,
});
